var map = {
	"./bs_web_stitch_top01_.png": 672884,
	"./bs_web_stitch_top01_blk.png": 505571,
	"./bs_web_stitch_top01_blu.png": 233757,
	"./bs_web_stitch_top01_cml.png": 57746,
	"./bs_web_stitch_top01_crk.png": 140232,
	"./bs_web_stitch_top01_grn.png": 548425,
	"./bs_web_stitch_top01_lgd.png": 904131,
	"./bs_web_stitch_top01_lsl.png": 45191,
	"./bs_web_stitch_top01_nvy.png": 981308,
	"./bs_web_stitch_top01_orn.png": 469297,
	"./bs_web_stitch_top01_pnk.png": 991099,
	"./bs_web_stitch_top01_ppl.png": 195658,
	"./bs_web_stitch_top01_red.png": 321895,
	"./bs_web_stitch_top01_sax.png": 973938,
	"./bs_web_stitch_top01_wht.png": 397293,
	"./bs_web_stitch_top01_ylw.png": 304951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 684423;